/** Strip non-digits for API field `contact_person_country_code` (store without +). */
export function normalizeDialCodeDigits(raw) {
  if (raw == null) return "";
  return String(raw).replace(/\D/g, "");
}
